export default {
	methods: {
		/**
		 * Retrieve the user hasAccess field corresponding to its index type
		 * @param {number} index - Index of the user (corresponding to type field) between 1-3
		 * @return {string} Returns the Oui/Non for hasAccess field
		 */
		getUserDashboardAccess: index => {
			switch(index) {
			case 0: {
				return "Non";
			}
			case 1: {
				return "Oui";
			}
			default: {
				return "";
			}
			}
		},

		/**
		 * Retrieve the user title corresponding to its index type
		 * @param {number} index - Index of the user (corresponding to type field) between 1-3
		 * @return {string} Returns the title
		 */
		getUserTitle: index => {
			switch(index) {
			case 1: {
				return "Facturation";
			}
			case 2: {
				return "Commercial(e)";
			}
			case 3: {
				return "Consultant";
			}
			case 4: {
				return "Sales";
			}
			case 5: {
				return "Technique";
			}
			case 6: {
				return "Administrateur";
			}
			case 7: {
				return "Collaborateur externe";
			}
			case 8: {
				return "Comptabilité";
			}
			case 9: {
				return "Super Administrateur";
			}
			default: {
				return "";
			}
			}
		},

		getCollaboratorTypeForClient: index => {
			switch(index) {
			case 0: {
				return "Commercial(e)";
			}
			case 1: {
				return "Consultant";
			}
			case 2: {
				return "Service Comptabilité";
			}
			default: {
				return "";
			}
			}
		},

		getContactType: index => {
			switch(index) {
			case 0: {
				return "Commercial(e)";
			}
			case 1: {
				return "Facturation";
			}
			case 2: {
				return "Commercial(e)";
			}
			case 5: {
				return "Technique";
			}
			case 7: {
				return "Collaborateur externe";
			}
			default: {
				return "";
			}
			}
		},

		/**
		 * Retrieve the status corresponding to its status value
		 * @param {number} index - Value of the status (corresponding to status field) between 0-1
		 * @return {string} Returns the status
		 */
		getStatus: index => {
			switch(index) {
			case 0: {
				return "Inactif";
			}
			case 1: {
				return "Actif";
			}
			default: {
				return "Inactif";
			}
			}
		},

		/**
		 * Retrieve the user civility corresponding to its civility value
		 * @param {number} index - Value of the user civility (in the civility field) between 1-2
		 * @return {string} Returns the civility
		 */
		getUserCivility: index => {
			switch(index) {
			case 1: {
				return "Madame";
			}
			case 2: {
				return "Monsieur";
			}
			default: {
				return " ";
			}
			}
		},

		/**
		 * Retrieve the society origin corresponding to its origin value
		 * @param {number} index - Value of the society type (is_ecommerce) between 0-1
		 * @return {string} Returns the type
		 */
		getSocietyType: index => {
			switch(index) {
			case 0: {
				return "Vitrine";
			}
			case 1: {
				return "E-commerce";
			}
			default: {
				return " ";
			}
			}
		},

		/**
		 * Retrieve the society origin corresponding to its origin value
		 * @param {number} index - Value of the origin (corresponding to origin field) between 1-5
		 * @return {string} Returns the origin
		 */
		getSocietyOrigin: index => {
			switch(index) {
			case 1: {
				return "Agence";
			}
			case 2: {
				return "Salon";
			}
			case 3: {
				return "Prospection";
			}
			case 4: {
				return "Appel Entrant";
			}
			case 5: {
				return "Réseau";
			}
			case 6: {
				return "Lead entrant";
			}
			case 7: {
				return "Apporteur d'affaire";
			}
			case 8: {
				return "Événements";
			}
			default: {
				return " ";
			}
			}
		},

		/**
		 * Retrieve the string value of a product category using its index
		 * @param {number} index - Value of the product category or delivery (between 0 - 3)
		 * @return {string} returns the name of the product category
		 */
		getProductCategoryName: index => {
			if(!index) index = "0";
			switch(index.toString()) {
			case"1": {
				return "SEO";
			}
			case"2": {
				return "SEA";
			}
			case"3": {
				return "E-\u00a0Réputation";
			}
			case"4": {
				return "Social Ads";
			}
			case"5": {
				return "RP Digitale";
			}
			case"6": {
				return "Formation";
			}
			case"7": {
				return "Autre";
			}
			default: {
				return "SEO";
			}
			}
		},

		/**
		 * Retrieve the string value of a product using it's index
		 * @param {number} index - Value of the netlink (between 0-1)
		 * @return {string} returns the name of the netlink
		 */
		getNetlinkName: index => {
			if(index === 1) return "Netlink";
			else return "Non netlink";
		},

		/**
		 * Retrieve the string value of a netlink's status using its status index
		 * @param {number} index - Value of the contract status (between 0 - 3)
		 * @return {string} netlink status
		 */
		getNetlinkStatus: index => {
			switch(String(index)) {
			case"0": {
				return "Actif";
			}
			case"1": {
				return "En\u00a0attente";
			}
			case"2": {
				return "Refusé";
			}
			case"3": {
				return "Terminé";
			}
			case"4": {
				return "En\u00a0cours\u00a0de\u00a0rédaction";
			}
			case"5": {
				return "Annulé";
			}
		case"6": {
			return "Litige";
		}
			default: {
				return "Non\u00a0Renseigné";
			}
			}
		},

		getNetlinkStatusColor: index => {
			switch(String(index)) {
			case"0": {
				return "#27C46D";
			}
			case"1": {
				return "rgb(24, 123, 205)";
			}
			case"2": {
				return "rgb(181, 120, 9)";
			}
			case"3": {
				return "#FF0000";
			}
			case"4": {
				return "rgb(233, 105, 200)";
			}
			case"5": {
				return "rgb(192, 192, 192)";
			}
		case"6": {
			return "#FF9800";
		}
			default: {
				return "Non\u00a0Renseigné";
			}
			}
		},

		getOrderStatus: index => {


			switch(index) {
			case 1: {
				return "À faire";
			}
			case 2: {
				return "Fait";
			}
			case 3: {
				return "Annulé";
			}
			case 4: {
				return "Terminée";
			}
			default: {
				return "Non\u00a0Renseigné";
			}
			}
		},

		getOrderStatusColor: index => {
			switch(index) {
			case 1: {
				return "rgb(24, 123, 205)";
			}
			case 2: {
				return "rgb(233, 105, 200)";
			}
			case 3: {
				return "rgb(183,7,237)";
			}
			case 4: {
				return "danger";
			}
			case 4: {
				return "rgb(233, 105, 200)";
			}
			case 5: {
				return "rgb(192, 192, 192)";
			}
			default: {
				return "Non\u00a0Renseigné";
			}
			}
		},
		getProvidersStatus: () => {
			return [{
				id: 1, name: "Actif"},
			{id: 2, name: "In actif"
			},{id: 0, name: "Non renseigné"}];
		},
		getProviderStatusColor: index => {
			switch(index) {
			case 1: {
				return "success";
			}
			case 2: {
				return "warning";
			}

			default: {
				return "Non\u00a0Renseigné";
			}
			}
		},

		/**
		 * Retrieve the string value of a netlink's anchor type using its status index
		 * @param {number} index - Value of the contract status (between 0 - 3)
		 * @return {string} netlink anchor type
		 */
		getNetlinkAnchorType: index => {
			switch(index) {
			case 0: {
				return "Brand\u00a0et\u00a0Générique";
			}
			case 1: {
				return "Semi optimisée";
			}
			case 2: {
				return "Générique";
			}
			default: {
				return "Non\u00a0Renseigné";
			}
			}
		},

		/**
		 * Retrieve the string value of a netlink's link type using its status index
		 * @param {number} index - Value of the contract status (between 0 - 3)
		 * @return {string} netlink link type
		 */
		getNetlinkLinkType: index => {
			switch(index) {
			case 1: {
				return "Location\u00a0HP";
			}
			case 2: {
				return "Article\u00a0Sponsorisé";
			}
			case 3: {
				return "NDD\u00a0expiré\u00a0en\u00a0redirection";
			}
			case 4: {
				return "NDD\u00a0expiré\u00a0mini-site";
			}
			case 5: {
				return "Lien\u00a0Sponsorisé";
			}
			case 6: {
				return "Forum";
			}
			case 7: {
				return "Annuaire";
			}
			case 8: {
				return "Article-site";
			}
			case 9: {
				return "Sitewide links";
			}
			case 10: {
				return "Contextual Location Homepage";
			}
			case 11: {
				return "Média Référent";
			}
			case 12: {
				return "RP digitale";
			}
			default: {
				return "Non\u00a0Renseigné";
			}
			}
		},

		/**
		 * Retrieve the string value of a contract's type using its type index
		 * @param {number} index - Value of the contract type (between 0 - 1)
		 * @return {string} returns the type of the contract
		 */
		getContractTypeName: index => {
			if(!index) index = 0;
			switch(index) {
			case 0: {
				return "One\u00a0Shot";
			}
			case 1: {
				return "Mensuel";
			}
			default: {
				return "Non\u00a0renseigné";
			}
			}
		},

		/**
		 * Retrieve the string value of a contract's status using its status index
		 * @param {number} index - Value of the contract status (between 0 - 3)E
		 * @return {string} contract status
		 */
		getContractStatus: index => {
			switch(index) {
			case 0: {
				return "Inactif";
			}
			case 1: {
				return "Actif";
			}
			case 2: {
				return "A\u00a0Valider";
			}
			case 3: {
				return "En\u00a0pause";
			}
			case 4: {
				return "Terminé";
			}
			case 5: {
				return "Annulé";
			}
			case 6: {
				return "Perdu";
			}
			case 7: {
				return "Livré";
			}
			case 8: {
				return "A venir";
			}
			case 9: {
				return "Relance";
			}
			default: {
				return "Non\u00a0Renseigné";
			}
			}
		},
		//getting mission status
		getContractStatusList: () => {
			return [
				{"text": "Inactif", "value": 0},
				{"text": "Actif", "value": 1},
				{"text": "A\u00a0Valider", "value": 2},
				{"text": "En\u00a0pause", "value": 3},
				{"text": "Terminé", "value": 4},
				{"text": "Annulé", "value": 5},
				{"text": "Perdu", "value": 6},
				{"text": "A venir", "value": 8},
				{"text": "Relance", "value": 9},
			];
		},

		getTaskStatus: index => {
			switch(index) {
			case 0: {
				return "À faire";
			}
			case 1: {
				return "Fait";
			}
			case 2: {
				return "Annulé";
			}
			default: {
				return "Non\u00a0Renseigné";
			}
			}
		},

		/**
		 * Retrieve the string value of a contract's Recurrence using its Recurrence index
		 * @param {number} index - Value of the contract Recurrence (between 0 - 3)
		 * @return {string} contract Recurrence
		 */
		getContractRecurrence: index => {
			switch(index) {
			case 0: {
				return "Non\u00a0récurrent";
			}
			case 1: {
				return "Récurrent";
			}
			default: {
				return "Non\u00a0récurrent";
			}
			}
		},

		/**
		 * Retrieve the string value of a contract's frequency using its frequency index
		 * @param {number} index - Value of the contract frequency (between 0 - 4)
		 * @return {string} contract frequency
		 */
		getContractFrequency: index => {
			switch(index) {
			case 0: {
				return "Mensuelle";
			}
			case 1: {
				return "Bimestrielle";
			}
			case 2: {
				return "Trimestrielle";
			}
			case 3: {
				return "Quadrimestrielle";
			}
			case 4: {
				return "Annuelle";
			}
			default: {
				return " ";
			}
			}
		},

		/**
		 * Retrieve the string value of a purchase's frequency using its frequency index
		 * @param {number} index - Value of the purchase frequency (between 0 - 4)
		 * @return {string} purchase frequency
		 */
		getPurchaseFrequency: index => {
			switch(index) {
			case 0: {
				return "One shot";
			}
			case 1: {
				return "Mensuel";
			}
			case 2: {
				return "Bimestriel";
			}
			case 3: {
				return "Trimestriel";
			}
			case 4: {
				return "Quadrimestriel";
			}
			case 5: {
				return "Semestriel";
			}
			case 6: {
				return "Annuel";
			}
			default: {
				return " ";
			}
			}
		},

		/**
		 * Retrieve the string value of a contract's status color using its status color index
		 * @param {number} index - Value of the contract status (between 0 - 3)
		 * @returns {string} RGB color or class color
		 */
		getContractStatusColor: index => {
			switch(index) {
			case 0: {
				return "rgb(192,192,192)";
			}
			case 1: {
				return "success";
			}
			case 2: {
				return "rgb(240,230,140)";
			}
			case 3: {
				return "rgb(187, 138, 200)";
			}
			case 41:
			case 42:
			case 43:
			case 44:
			case 45:
			case 46:
			case 4: {
				return "danger";
			}
			case 5: {
				return "rgb(192,192,192)";
			}
			case 6: {
				return "rgb(192,192,192)";
			}
			case 7: {
				return "rgb(183,7,237)";
			}
			case 8: {
				return "rgb(24, 123, 205)";
			}
			case 9: {
				return "warning";
			}
			default: {
				return "Non\u00a0Renseigné";
			}
			}
		},

		getTaskStatusColor: index => {
			switch(index) {
			case 0: {
				return "warning";
			}
			case 1: {
				return "success";
			}
			case 2: {
				return "danger";
			}
			default: {
				return "gray";
			}
			}
		},

		getLang: index => {
			switch(index) {
			case 1: {
				return "Français";
			}
			case 2: {
				return "Anglais";
			}
			case 3: {
				return "Anglais";
			}
			case 4: {
				return "Chinois simplifié";
			}
			case 5: {
				return "Japonais";
			}
			case 6: {
				return "Coréen";
			}
			default: {
				return " ";
			}
			}
		},
		getTermineType(index){
			switch(index) {
			case 7: {
				return "Impayé";
			}
			case 1: {
				return "Insatisfaction client";
			}
			case 2: {
				return "Manque de résultat";
			}
			case 4: {
				return "Prestation livrée";
			}
			case 5: {
				return "Fin de contrat";
			}
			case 6: {
				return "Autre";
			}
			case 3: {
				return "Manque de budget";
			}
			default: {
				return "";
			}
			}

		},


		/**
		 * Retrieve the commercial user from a list of users related to a contract
		 * @param {Array<object>} users - List of user
		 * @return {object} Returns the commercial from the list or NULL
		 */
		getCommercial: users => {
			let data = JSON.parse(users);
			let final = null;
			data.map(user => {
				// TYPE 2 = COMMERCIAL
				if(user.type == 2) {
					final = user;
				}
			});
			return final;
		},

		/**
		 * Retrieve the account manager user from a list of users related to a contract
		 * @param {Array<object>} users - List of user
		 * @return {object} Returns the account manager from the list or NULL
		 */
		getAccountManager: users => {
			let data = JSON.parse(users);
			let final = null;
			data.map(user => {
				// TYPE 3 = Account Manager
				if(user.type == 3) {
					final = user;
				}
			});
			return final;
		},


		/**
		 * Retrieve commercial contact user from a list of users related to a contract
		 * @param {Array<object>} users - List of user
		 * @return {object} Returns the commercial contact for a society from the list or NULL
		 */
		getCommercialContact: users => {
			let final = null;
			users.map(user => {
				// ROLE 2 = Contact
				if(user.role === 2) {
					// TYPE 2 = commercial
					if(user.type === 2) {
						final = user;
					}
				}
			});
			return final;
		},

		/**
		 * Retrieve billing contact user from a list of users related to a contract
		 * @param {Array<object>} users - List of user
		 * @return {object} Returns the billing contact for a society from the list or NULL
		 */
		getBillingContact: users => {
			let final = null;
			users.map(user => {
				// ROLE 2 = Contact
				if(user.role === 2) {
					// TYPE 1 = Billing
					if(user.type === 1) {
						final = user;
					}
				}
			});
			return final;
		},

		/**
		 * Retrieve commercial for a society  from a list of users related to a contract
		 * @param {Array<object>} users - List of user
		 * @return {object} Returns the commercial in charge of a society from the list or NULL
		 */
		getRankwellCommercial: users => {
			let final = null;
			users.map(user => {
				if(user.role === 1) {
					if(user.type === 2) {
						final = user;
					}
				}
			});
			return final;
		},

		/**
		 * Convert Siret to database format removing space characters
		 * @param {String} siret Siret to convert
		 * @return {String} Converted siret
		 */
		transformSiretDbFormat: siret => {
			return siret.split(" ").join("");
		},

		/**
		 * Convert International format number to French format
		 * @param {Number} intNumber International formated Number
		 * @return {Number} French formated number
		 */
		convertInternationalNumberToFrench: intNumber => {
			return new Intl.NumberFormat("fr-FR").format(intNumber);
		},

		/**
		 * Convert international format number to French format with currency
		 * @param {Number} intNumber International formated Number
		 * @return {Number} French formated number
		 */
		convertInternationalNumberToFrenchCurrency: intNumber => {
			return new Intl.NumberFormat("fr-FR", {style: "currency", currency: "EUR"}).format(intNumber);
		},

		/**
		 * Convert French format number to international format
		 * @param {String} frenchNumber French formated Number
		 * @return {Number} International formated number
		 */
		convertFrenchNumberToInternational: frenchNumber => {
			return new Number(frenchNumber.toString().replace(/,/g, "."));
		},

		/**
		 * Get status option accordinly
		 * @param {Number} status
		 * @param {String} role
		 * @return {Number} International formated number
		 */
		getStatusOptionContract(missionStatus, contractStatus, isSAdim){
			//console.log("contractStatus", contractStatus);
			if(contractStatus == 2){
				return [
					{text: "Actif", value: 1},
					{text: "A Valider", value: 2},
					{text: "Annulé", value: 5}
				];
			}
			else{
				if(isSAdim){
					if(missionStatus == 7){
						return [
							{text: "Livré", value: 7},
							{text: "Terminé", value: 4}
						];
					}
					else{
						if(missionStatus == 8){
							return [
								{text: "A venir", value: 8},
								{text: "Annulé", value: 5},
								{text: "En pause", value: 3},
								{text: "Terminé", value: 4},
							];
						}
						else{
							return [
								{text: "Actif", value: 1},
								{text: "Annulé", value: 5},
								{text: "En pause", value: 3},
								{text: "Terminé", value: 4},
								{text: "Relance", value: 9},
							];
						}
					}
				}
				else{
					if([7, 8, 9].includes(missionStatus)){
						return [];
					}
					else{
						return [
							{text: "Actif", value: 1},
							{text: "Annulé", value: 5},
							{text: "En pause", value: 3},
						];
					}
				}
			}
		},
		getFacturationOptionList(){
			return [{id: 1, name: "Avant livraison"},
				{id: 2, name: "Après  livraison"}];
		},
		getFacturationDelayTime(){
			return [{id: 1, name: "Dès réception"},
				{id: 2, name: "15 jours"},
				{id: 3, name: "30 jours"},
				{id: 4, name: "60 jours"},
			];
		},
		getFacturationMethod(){
			return [{id: 1, name: "Prélèvement Sepa"},
				{id: 2, name: "Virement"},
			];
		},
	}
};
